module.exports = __webpack_public_path__ + "static/media/shash.160ab30d.wav";